module.exports = __webpack_public_path__ + "static/media/geometric-new.a22f8265.png";